<div class="container">
  


  <mat-card class="card">
    <page-alert *ngIf="submitted && success" message="Agendamento Confirmado" alertClass="alert-success"></page-alert>
    <page-alert *ngIf="submitted && !success" message="Agendamento não corresponde" alertClass="alert-danger"></page-alert>
    <mat-card-content>
      <h2>Confirmação de Agendamento</h2>
      <form [formGroup]="paymentForm">
        <div class="checkbox-group">
          <mat-checkbox formControlName="approve" >Aprovar</mat-checkbox>
          <mat-checkbox formControlName="reject">Reprovar</mat-checkbox>
        </div>

        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Valor a ser pago</mat-label>
          <input matInput type="number" formControlName="amount" />
        </mat-form-field>

        <button mat-raised-button color="primary" (click)="onSubmit()">Enviar</button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
